<template>

    <div class="main-container">
        <!-- Background Image Grid -->
        <div class="image-grid">
            <div class="image-column">
                <img v-no-right-click src="https://dummyimage.com/300x400/e83e8c/e83e8c" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/20c997/20c997" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
            </div>
            <div class="image-column d-none d-md-block">
                <img v-no-right-click src="https://dummyimage.com/300x350/6f42c1/6f42c1" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x400/dc3545/dc3545" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
            </div>
            <div class="image-column d-none d-lg-block">
                <img v-no-right-click src="https://dummyimage.com/300x400/007bff/007bff" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/6610f2/6610f2" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x350/17a2b8/17a2b8" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x350/17a2b8/17a2b8" alt="Grid Image"> 
            </div>
            <div class="image-column">
                <img v-no-right-click src="https://dummyimage.com/300x400/e83e8c/e83e8c" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/20c997/20c997" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
            </div>
            <div class="image-column d-none d-md-block">
                <img v-no-right-click src="https://dummyimage.com/300x350/6f42c1/6f42c1" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x400/dc3545/dc3545" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
            </div>
            <div class="image-column d-none d-lg-block">
                <img v-no-right-click src="https://dummyimage.com/300x400/007bff/007bff" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/6610f2/6610f2" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x350/17a2b8/17a2b8" alt="Grid Image">  
                <img v-no-right-click src="https://dummyimage.com/300x350/17a2b8/17a2b8" alt="Grid Image">  
            </div> 
            <div class="image-column">
                <img v-no-right-click src="https://dummyimage.com/300x400/e83e8c/e83e8c" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/20c997/20c997" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
            </div>
            <div class="image-column d-none d-md-block">
                <img v-no-right-click src="https://dummyimage.com/300x350/6f42c1/6f42c1" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x400/dc3545/dc3545" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
            </div> 
        </div>

        <!-- Login Form Container -->
        <div class="login-container">
            <div class="login-box">
                <div class="text-center mb-4">
                    <img v-no-right-click src="/assets/logo-icon.png" style="height:55px" alt="Logo" class="logo rounded">
                    <h2 class="welcome-text">Join into Invi8</h2>
                </div>  

                <form @submit.prevent="handleRegister" autocomplete="none">
                    <div class="form-group">
                        <input type="text" v-model="form.full_name" class="form-control" placeholder="Full Name">
                    </div>
                    <div class="form-group">
                        <input type="text" v-model="form.email" class="form-control" placeholder="Email">
                    </div>
                    <div class="form-group">
                        <input type="text" v-model="form.username" class="form-control" placeholder="Username">
                    </div>
                    <div class="form-group password-group">
                        <input
                          :type="showPassword ? 'text' : 'password'"
                          v-model="form.password"
                          class="form-control"
                          placeholder="Password"
                        >
                        <button
                          type="button"
                          class="generate-password"
                          @click="generateSecurePassword"
                          title="Generate secure password"
                        >
                          <i class="fas fa-random"></i>
                        </button>
                        <button
                          type="button"
                          class="toggle-password"
                          @click="showPassword = !showPassword"
                          :aria-label="showPassword ? 'Hide password' : 'Show password'"
                        >
                          <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                        </button>
                    </div> 
                    <div class="password-strength mt-2">
                      <div class="strength-header">
                        Password strength:
                        <span :class="['strength-label', passwordStrengthClass]">
                          {{ passwordStrengthLabel }}
                        </span>
                      </div>
                      <div class="strength-bar">
                        <span
                          class="strength-bar__fill"
                          :class="passwordStrengthClass"
                          :style="{ width: `${(passwordStrengthScore / 5) * 100}%` }"
                        ></span>
                      </div>
                      <ul class="requirements-list">
                        <li
                          v-for="req in passwordRequirements"
                          :key="req.key"
                          :class="{ met: passwordChecks[req.key] }"
                        >
                          <i :class="passwordChecks[req.key] ? 'fas fa-check' : 'fas fa-times'"></i>
                          {{ req.label }}
                        </li>
                      </ul>
                    </div>
                    <div class="form-group password-group">
                        <input
                          :type="showConfirmPassword ? 'text' : 'password'"
                          v-model="form.confirm_password"
                          class="form-control"
                          placeholder="Confirm Password"
                        >
                        <button
                          type="button"
                          class="toggle-password"
                          @click="showConfirmPassword = !showConfirmPassword"
                          :aria-label="showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'"
                        >
                          <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                        </button>
                    </div> 
                    <button type="submit" class="btn btn-pinterest btn-block" :disabled="isRegisterDisabled">
                      Register
                    </button>

                </form> 

                <div class="mt-4 text-center">
                    <p class="mb-0">Already've an account? <router-link to="/login">Login</router-link></p> 
                </div>
            </div>
        </div>
    </div> 
 
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import Swal from 'sweetalert2'
import { useSessionStore } from '@/stores/session'
import api from '@/services/api' 
import { useHead } from '@vueuse/head'


useHead({
  title: 'Invi8 - User Register',
  meta: [
    { name: 'description', content: 'Welcome to the home page of My Awesome Site.' },
    { name: 'keywords', content: 'home, awesome site, vue 3, pwa' },
  ],
})
const router = useRouter()
const store = useSessionStore()

const form = reactive({
  username: '',
  password: '',
  confirm_password: '',
  full_name: '',
  email: ''
})
const showPassword = ref(false)
const showConfirmPassword = ref(false)
const isSubmitting = ref(false)

const passwordChecks = computed(() => {
  const value = form.password || ''
  return {
    length: value.length >= 8,
    uppercase: /[A-Z]/.test(value),
    lowercase: /[a-z]/.test(value),
    number: /\d/.test(value),
    special: /[^A-Za-z0-9]/.test(value)
  }
})

const passwordStrengthScore = computed(() => Object.values(passwordChecks.value).filter(Boolean).length)
const passwordStrengthLabel = computed(() => {
  const score = passwordStrengthScore.value
  if (!form.password) return 'Enter a password'
  if (score <= 2) return 'Weak'
  if (score === 3 || score === 4) return 'Medium'
  return 'Strong'
})
const passwordStrengthClass = computed(() => {
  if (!form.password) return 'empty'
  const score = passwordStrengthScore.value
  if (score <= 2) return 'weak'
  if (score === 3 || score === 4) return 'medium'
  return 'strong'
})
const isPasswordStrong = computed(() => Object.values(passwordChecks.value).every(Boolean))
const passwordRequirements = [
  { key: 'length', label: 'At least 8 characters' },
  { key: 'uppercase', label: 'Contains uppercase letter' },
  { key: 'lowercase', label: 'Contains lowercase letter' },
  { key: 'number', label: 'Contains number' },
  { key: 'special', label: 'Contains special character' }
]

const generateSecurePassword = () => {
  const uppercase = 'ABCDEFGHJKLMNOPQRSTUVWXYZ'
  const lowercase = 'abcdefghijkmnopqrstuvwxyz'
  const numbers = '23456789'
  const symbols = '@#$%&*!?'
  const allChars = uppercase + lowercase + numbers + symbols

  const pick = (str, len = 1) =>
    Array.from({ length: len }, () => str[Math.floor(Math.random() * str.length)]).join('')

  const required = [
    pick(uppercase),
    pick(lowercase),
    pick(numbers),
    pick(symbols)
  ]

  const remainingLength = 12 - required.join('').length
  const remaining = pick(allChars, Math.max(remainingLength, 4))

  const combined = (required.join('') + remaining).split('')
  for (let i = combined.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[combined[i], combined[j]] = [combined[j], combined[i]]
  }
  const pwd = combined.join('')
  form.password = pwd
  form.confirm_password = pwd
}

const isRegisterDisabled = computed(() => {
  const hasRequiredFields =
    (form.full_name || '').trim() &&
    (form.email || '').trim() &&
    (form.username || '').trim() &&
    form.password &&
    form.confirm_password

  return !hasRequiredFields ||
    !isPasswordStrong.value ||
    form.password !== form.confirm_password ||
    isSubmitting.value
})

// Helpers
const getBrowserTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
};

const getGMTOffsetString = () => {
  // Date.getTimezoneOffset() returns minutes *behind* UTC (IST = -330)
  const minutesFromUTC = -new Date().getTimezoneOffset(); // +330 for IST
  const sign = minutesFromUTC >= 0 ? '+' : '-';
  const abs = Math.abs(minutesFromUTC);
  const hh = String(Math.floor(abs / 60)).padStart(2, '0');
  const mm = String(abs % 60).padStart(2, '0');
  return `GMT${sign}${hh}:${mm}`; // e.g., "GMT+05:30"
};

const handleRegister = async () => {
  if (isSubmitting.value) return;

  // --- Gather + sanitize inputs
  const name = (form.full_name || '').trim();
  const email = (form.email || '').trim().toLowerCase();
  const username = (form.username || '').trim();
  const password = form.password || '';
  const confirmPassword = form.confirm_password || '';

  // --- Validation rules
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  const usernameRegex = /^[a-zA-Z0-9._]{3,20}$/; // 3–20 chars; letters, numbers, dot, underscore
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

  // --- Validate in order (show first error)
  if (!name) {
    Swal.fire('Error', 'Full Name is required.', 'error');
    return;
  }
  if (!email) {
    Swal.fire('Error', 'Email ID is required.', 'error');
    return;
  }
  if (!emailRegex.test(email)) {
    Swal.fire('Error', 'Please enter a valid email address.', 'error');
    return;
  }
  if (!username) {
    Swal.fire('Error', 'Username is required.', 'error');
    return;
  }
  if (!usernameRegex.test(username)) {
    Swal.fire(
      'Error',
      'Username must be 3–20 characters and can contain letters, numbers, dot (.) and underscore (_).',
      'error'
    );
    return;
  }
  if (!password) {
    Swal.fire('Error', 'Password is required.', 'error');
    return;
  }
  if (!passwordRegex.test(password)) {
    Swal.fire(
      'Error',
      'Password must be at least 8 characters and include uppercase, lowercase, number, and special character.',
      'error'
    );
    return;
  }
  if (!confirmPassword) {
    Swal.fire('Error', 'Confirm Password is required.', 'error');
    return;
  }
  if (password !== confirmPassword) {
    Swal.fire('Error', 'Passwords do not match.', 'error');
    return;
  }

  // --- Auto timezone/zone from the browser
  const timezone = getBrowserTimeZone();      // e.g., "Asia/Kolkata"
  const zone = getGMTOffsetString();          // e.g., "GMT+05:30"

  try {
    isSubmitting.value = true;

    const formData = new FormData();
    formData.append('name', name);
    formData.append('email', email);
    formData.append('username', username);
    formData.append('password', password);
    formData.append('timezone', timezone);
    formData.append('zone', zone);

    const { data } = await api.registerApi(formData);
    console.log('Register API Response:', data);

    if (data?.status === 'ok' && Array.isArray(data?.data) && data.data.length > 0) {
      store.setUser(data.data[0]); // persist the full user object
      Swal.fire('Success', 'Registration successful!', 'success');
      router.push('/host');
    } else {
      Swal.fire('Registration Failed', data?.message || 'Invalid information.', 'error');
    }
  } catch (err) {
    console.error('Register error:', err);
    const msg =
      err?.response?.data?.message ||
      err?.message ||
      'Something went wrong. Please try again.';
    Swal.fire('Server Error', msg, 'error');
  } finally {
    isSubmitting.value = false;
  }
};


</script>

<style>
/* Main Container */
.main-container {
    min-height: 100%;
    display: flex;
    position: relative;
    overflow: hidden;
}

/* Image Grid Styles */
.image-grid {
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    opacity: 1;
    z-index: -1;
}

.image-column {
    flex: 1;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.image-column img {
    width: 100%;
    border-radius: 16px;
    object-fit: cover;
    margin-bottom: 20px;
}

/* Login Container Styles */
.login-container {
    width: 100%;
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 100px 0px;
    background: rgba(255, 255, 255, 0.9);
}

.login-box {
    background: white;
    padding: 30px;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
}

/* Logo and Welcome Text */
.logo {
    border-radius: 50%;
    margin-bottom: 10px;
}

.welcome-text {
    font-size: 32px;
    font-weight: 600;
    color: #333;
    margin-bottom: 20px;
}

/* Form Elements */
.form-control {
    border-radius: 16px;
    padding: 12px 16px;
    font-size: 16px;
    border: 2px solid #efefef;
}

.form-control:focus {
    border-color: #FB7210;
    box-shadow: none;
}

.password-group {
    position: relative;
}
.password-group .form-control {
    padding-right: 75px;
}
.generate-password,
.toggle-password {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    background: transparent;
    color: #6c757d;
    cursor: pointer;
    padding: 4px;
}
.generate-password {
    right: 42px;
}
.toggle-password {
    right: 12px;
}
.generate-password:focus,
.toggle-password:focus {
    outline: none;
}

.password-strength {
    background: #f9f9f9;
    border-radius: 12px;
    padding: 10px 14px;
    margin-bottom: 12px;
}
.strength-header {
    font-size: 13px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.strength-label {
    text-transform: capitalize;
}
.strength-label.empty { color: #6c757d; }
.strength-label.weak { color: #d9534f; }
.strength-label.medium { color: #ff9800; }
.strength-label.strong { color: #28a745; }
.strength-bar {
    height: 6px;
    background: #eaeaea;
    border-radius: 999px;
    margin: 8px 0 12px;
    overflow: hidden;
}
.strength-bar__fill {
    display: block;
    height: 100%;
    width: 0;
    border-radius: 999px;
    transition: width 0.25s ease;
}
.strength-bar__fill.empty { background: #ccc; }
.strength-bar__fill.weak { background: #d9534f; }
.strength-bar__fill.medium { background: #ff9800; }
.strength-bar__fill.strong { background: #28a745; }
.requirements-list {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 12px;
}
.requirements-list li {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #888;
    margin-bottom: 4px;
}
.requirements-list li.met {
    color: #28a745;
}

.forgot-password {
    color: #333;
    text-decoration: none;
    font-weight: 500;
    font-size: 14px;
}

.forgot-password:hover {
    color: #FB7210;
    text-decoration: underline;
}

/* Buttons */
.btn {
    border-radius: 20px;
    padding: 12px 16px;
    font-weight: 600;
    font-size: 15px;
}

.btn-pinterest {
    background-color: #FB7210;
    color: white;
    border: none;
}

.btn-pinterest:hover {
    background-color: #ad081b;
    color: white;
}
.btn[disabled] {
    opacity: 0.6;
    cursor: not-allowed;
}

.btn-facebook {
    background-color: #1877f2;
    color: white;
    border: none;
}

.btn-facebook:hover {
    background-color: #0d65d9;
    color: white;
}

.btn-google {
    background-color: white;
    color: #333;
    border: 2px solid #efefef;
}

.btn-google:hover {
    background-color: #f8f8f8;
}

/* Divider */
.divider {
    text-align: center;
    margin: 20px 0;
    position: relative;
}

.divider::before,
.divider::after {
    content: "";
    position: absolute;
    top: 50%;
    width: 45%;
    height: 1px;
    background-color: #efefef;
}

.divider::before {
    left: 0;
}

.divider::after {
    right: 0;
}

.divider span {
    background-color: white;
    padding: 0 10px;
    color: #666;
    font-size: 14px;
}

/* Business Text */
.business-text {
    color: #666;
    font-size: 12px;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
    .login-box {
        padding: 20px;
    }
    
    .welcome-text {
        font-size: 24px;
    }
    
    .image-grid {
        opacity: 0.2;
    }
}

@media (max-width: 576px) {
    .login-container {
        padding: 10px;
    }
    
    .login-box {
        box-shadow: none;
    }
    
    .image-grid {
        opacity: 0.1;
    }
} 
</style>
